<div class="container-fluid pt-2">    
    <div class="row">
        <div class="col-md-10">
            <div class="mb-4">
                You Can add <b>1 Company</b> for whom you can build petitions during the free trail.
            </div><br>
            <div class="col-md-2"> 
                <button class="im-btn im-btn-primary im-btn-md mb-4" [disabled]="this.addClientCompanyBtn" (click)="viewConnection()"
                >+ ADD COMPANY </button>
            </div>
        </div>      
      </div>
      <mat-divider></mat-divider><br>
    <div class="bgWhite noMargin w100">
         <p-table [value]="userDetails" responsiveLayout="scroll">
            <ng-template pTemplate="header">
                <tr>
                    <th>Company Name</th>
                    <th>Contact Number</th>
                    <th>Email ID</th>
                    <th>Address</th>
                    <th>User Name (Role)</th>
                    <th>Action</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-userDetails>
                <tr *ngIf="this.attorneypetitionerUser">
                    <td>{{userDetails.company.companyName}}</td>
                    <td>{{userDetails.company.mobileContacts}}</td>
                    <td>{{userDetails.company.emailContact.email}}</td>
                    <td>{{userDetails.company.address1}}</td>
                    <td>{{this.attorneypetitionerUser}}</td>
                    <td>
                      <div class="ml-2">
                        <span class="ml-2 mr-2" *ngIf="userDetails"><mat-icon class="mr-1 icn"
                          matTooltip="Edit" (click)="editNewUser(userDetails)"
                          class="material-icons">edit</mat-icon></span>
                        <span *ngIf="userDetails" (click)="confirmDelete(userDetails)">
                          <mat-icon class="material-icons mr-1 icn" matTooltip="Delete User">delete</mat-icon>
                        </span>   
                      </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>    
    </div>
    <mat-divider></mat-divider><br>
    <div class="row mt-5">
        <div class="col-6"></div>
        <div class="col text-right">
          <button (click)="onCancel()" pButton type="button" class="align-top mr-4 p-button-secondary">
            Cancel
          </button>
          <div class="border-right d-inline-block mr-4" style="height:46px"></div>
          <button (click)="onPrevious()" class="im-btn im-btn-primary im-btn-md mr-2" [disabled]="">
            Previous
          </button>
          <button (click)="onNext()" class="im-btn im-btn-primary im-btn-md" [disabled]="">
            Next
          </button>
        </div>
      </div>
</div>